// EtiquettesDocument.jsx
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
    page: {
        flexDirection: "column",
        padding: 10,
        width: "150mm",
        height: "100mm",
        fontFamily: 'Helvetica',
    },

    // ============ STRUCTURE =============
    headerRow: {
        flexDirection: "column",
        marginBottom: 10,
    },
    sHeaderRow: {
        flexDirection: "row"
    },
    content: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    footer: {
        marginTop: "auto",
    },

    // ============ PREMIÈRE LIGNE ============
    zoneBlack: {
        backgroundColor: "#000",
        color: "#fff",
        padding: 3,
        width: "60%",
        fontWeight: 700,
        fontSize: 25,
        textAlign: 'center'
    },
    destWhite: {
        backgroundColor: "#fff",
        color: "#000",
        padding: 3,
        width: "40%",
        borderWidth: 1,
        borderColor: "#000",
        fontWeight: 700,
        fontSize: 25,
        textAlign: 'center'
    },

    // ============ TEXTE CENTRAL ============
    textName: {
        textAlign: 'center',
        fontSize: 30,
        fontWeight: 800,
        marginBottom: 5,
    },
    textAddress: {
        textAlign: 'center',
        fontSize: 20,
        fontWeight: 600,
    },

    // ============ DERNIÈRE LIGNE (TABLE) ============
    table: {
        display: 'table',
        width: '100%',
        borderWidth: 1,
        borderColor: '#000',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCol1: {
        width: '45%',
        backgroundColor: '#000000',
        color: '#FFFFFF',
        padding: 5,
    },
    tableCol2: {
        width: '45%',
        padding: 5
    },
    tableCol3: {
        width: '10%',
        backgroundColor: '#000000',
        color: '#FFFFFF',
        padding: 5,
        borderLeftWidth: 1,
        borderColor: '#000',
    },
    tableCell: {
        fontSize: 25,
        textAlign: 'center',
        fontWeight: 800,
    },
});

const STATES_LABELS = {
    social: "social",
    locker: "consigne",
    parcel_shop: "commerce",
};

export default function LabelDocument({ bags }) {
    return (
        <Document>
            {bags.map((bag, index) => {
                const route = bag.routes?.[0] || {};
                const routeName = route.route_name || "";
                const sequenceInRoute = route.sequence_in_route || "";
                const scheduledFor = route.scheduled_for
                    ? moment(route.scheduled_for).format('DD/MM/YYYY')
                    : "";

                const name = bag.name || " ";
                const hub = bag.destination_hub_code || " ";
                const city = bag.city || " ";
                const postalCode = bag.postal_code || " ";
                const pointType = STATES_LABELS[bag.point_to_type] || " ";
                const pointCode = bag.point_to_code || " ";
                const containerLabelCode = bag.container_label_code || " ";
                const bags_to_same_destination = bag.bags_to_same_destination || " ";

                return (
                    <Page
                        key={index}
                        size={{ width: 425.2, height: 283.5 }}
                        style={styles.page}
                    >
                        <View style={styles.headerRow}>
                            <View style={styles.sHeaderRow}>
                                <Text style={styles.zoneBlack}>
                                    {routeName} · #{sequenceInRoute}
                                </Text>
                                <Text style={styles.destWhite}>{hub}</Text>
                            </View>
                            <View style={styles.sHeaderRow}>
                                <Text style={styles.zoneBlack}>
                                    {scheduledFor}
                                </Text>
                                <Text style={styles.destWhite}>{pointCode}</Text>
                            </View>
                        </View>


                        <View style={styles.content}>
                            <Text style={styles.textName}>{name.toUpperCase()}</Text>
                            <Text style={styles.textAddress}>{city.toUpperCase()} {postalCode.toUpperCase()}</Text>
                        </View>

                        <View style={styles.footer}>
                            <View style={styles.table}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol1}>
                                        <Text style={styles.tableCell}>
                                            {pointType.toUpperCase()}
                                        </Text>
                                    </View>
                                    <View style={styles.tableCol2}>
                                        <Text style={styles.tableCell}>
                                            {containerLabelCode}
                                        </Text>
                                    </View>
                                    <View style={styles.tableCol3}>
                                        <Text style={styles.tableCell}>
                                            {bags_to_same_destination}
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </Page>
                );
            })}
        </Document>
    );
}